export default {
  init() {
    // JavaScript to be fired on all pages
    $('.carousel').slick({
    	dots:true,arrows:false
    });
    if($('iframe').length){
      $('iframe').each(function(){
        var w = $(this).width();
        var h = w * 0.5625;
        $(this).height(h);
      });
    }
    $('.hamburger').click(function(){
    	$('.nav-primary').toggleClass('open');
    	$(this).toggleClass('active');
    });
    $(window).scroll(function() {
      var s = $('.banner');
      var windowpos = $(window).scrollTop();
      if ( windowpos <= 1 ) {
        s.removeClass("scrolled");
      } else {
        s.addClass("scrolled");  
      }
      if($('.tiltedContent').length){
      	if($('.tiltedContent').isInViewport()){
	  		$('.tiltedContent').addClass('tilt');
	  	}		
      }
      if($('iframe').length){
        $('iframe').each(function(){
          var w = $(this).width();
          var h = w * 0.5625;
          $(this).height(h);
        });
      }
    });
    $('.tabNav a').click(function(e){
      e.preventDefault();
      if($(this).hasClass('active')){
        return;
      }
      $('.tabNav .active').removeClass('active');
      var href=$(this).attr('href');
      $('.tab.active').removeClass('active').hide();
      $(href).addClass('active').fadeIn();
      $(this).addClass('active');

    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js